import React from 'react';
import './banner.css';
import {injectIntl} from "react-intl";

const LidarControllerBanner = () => {
    return (
        <div id="banner">
            <ul>
                <li>
                    <p><b>Please ignore below status - </b> Refer Scanless troubleshooting
                        <a target="_blank" rel="noopener noreferrer" href="https://w.amazon.com/bin/view/Last_Mile_Team/Smart-Station/Scanless/Lidar_Mechlite_Alpha_Launch_Plan/Maintenance_and_Troubleshooting"> guide </a>
                        and use commissioning tool.
                    </p>
                </li>
            </ul>
        </div>)
}

export default injectIntl(LidarControllerBanner)


// WEBPACK FOOTER //
// ./src/components/devicemanagement/thinclient/banner/LidarControllerBanner.js